export const initialValues = {
  firstname: "",
  lastname: "",
  civicRegistrationNumber: ""
};
